export default __webpack_public_path__ + "static/media/ioa-icon-tip.2da8c049.svg";